import {LocalCustomerModel} from './LocalCustomerModel';
import {RegionModel} from './RegionModel';
import { RoleModel } from './RoleModel';
import {ProviderModel} from './ProviderModel';
import {ContractTypeModel} from './ContractTypeModel';

export class UserModel {
  id: number;
  name: string;
  surname: string;
  mail: string;
  idRole: number;
  roleList: Array<string>;
  localCustomer: LocalCustomerModel;
  localCustomerList: Array<LocalCustomerModel>;
  providerList: Array<ProviderModel>;
  contractTypeList: Array<ContractTypeModel>;
  regionList: Array<RegionModel>;
  username: any;
  password: any;
  role: RoleModel;

  constructor(id?: number, name?: string, surname?: string,
              mail?: string, idRole?: number, localCustomer?: LocalCustomerModel,
              localCustomerList?: Array<LocalCustomerModel>, regionList?: Array<RegionModel>,
              roleList?: Array<string>, username?: any, password?: any, role?: RoleModel,
              providerList?: Array<ProviderModel>, contractTypeList?: Array<ContractTypeModel>) {
    this.id = id;
    this.name = name;
    this.surname = surname;
    this.mail = mail;
    this.idRole = idRole;
    this.localCustomer = localCustomer;
    this.localCustomerList = localCustomerList;
    this.regionList = regionList;
    this.username = username;
    this.password = password;
    this.role = role;
    this.roleList = roleList;
    this.providerList = providerList;
    this.contractTypeList = contractTypeList;
  }
}
